import { Button, ButtonGroup, Center, IconButton } from '@chakra-ui/react';
import * as React from 'react';

import { ChevronLeftIcon, ChevronRightIcon } from '@/imports/ui/chakra/feather';

export const Pagination: React.FC<{
  currentPage: number;
  numberOfPages: number;
  onChange: (value: number) => void;
}> = ({ currentPage, numberOfPages, onChange }) => {
  const PAGINATION_LENGTH = 5;
  const halfPaginationLength = Math.ceil(PAGINATION_LENGTH / 2);
  const start = Math.min(
    currentPage - halfPaginationLength > 0
      ? currentPage - halfPaginationLength
      : 0,
    numberOfPages - PAGINATION_LENGTH > 0
      ? numberOfPages - PAGINATION_LENGTH
      : 0
  );
  const end = start + PAGINATION_LENGTH;

  if (numberOfPages < 2) {
    return null;
  }

  return (
    <Center mt="6">
      <ButtonGroup colorScheme="gray">
        <IconButton
          isDisabled={currentPage === 1}
          icon={<ChevronLeftIcon />}
          aria-label="Next Page"
          onClick={() => onChange(currentPage - 1)}
          variant="outline"
        />
        {Array.from({ length: numberOfPages }, (_, i) => i + 1)
          .slice(start, end)
          .map((page) => {
            return (
              <Button
                key={page}
                variant={currentPage === page ? 'solid' : 'ghost'}
                onClick={() => onChange(page)}
              >
                {page}
              </Button>
            );
          })}
        <IconButton
          isDisabled={currentPage === numberOfPages}
          icon={<ChevronRightIcon />}
          aria-label="Previous Page"
          onClick={() => onChange(currentPage + 1)}
          variant="outline"
        />
      </ButtonGroup>
    </Center>
  );
};
